import React from 'react'
import Select, {components} from 'react-select'

import './CustomSelect.css'



const Control = (props) => {
  return (
    <>
      {
        props.hasValue ? <label className='react-select__lable'> { props.lable } </label> : null
      }
      
      <components.Control {...props} />
    </>
  );
};

// Если передаётся массив или объект, в котором нужно по ключу 
// составить пару {value, label} для селекта
export const prepareSelectsData = (data) => {
  if(Array.isArray(data)) {
    return data?.map(dist => ({value: dist, label: dist}))
  } 

  const optionsArray = []
  for(let key in data) {
    optionsArray.push({value: key, label: key});
  }
  return optionsArray;
}

export const prepareSelectsDataByKeyValue = (data) => {
  const optionsArray = []
  for(let key in data) {
    // Для структуры объекта, если значение ключа так же является объектом
    // пример: value: {label:{}}
    const label = Object.keys(data[key])[0]
    optionsArray.push({value: key, label: label});
  }
  return optionsArray;
}

export const CustomSelect = (props) => {

  const getOptionClassList = (state) => {
    let classList = ''

    if (state.isSelected) {
      classList += ' react-select__selected'
    }
    if (state.isFocused) {
      classList += ' react-select__hover'
    }

    return classList
  }

  const setChoice = (choice) => {
    props.onChange(choice);
  }

  const {placeholder} = props;

  return (
    <Select options={props.options} 
      className='react-select'
      placeholder={placeholder}
      value={props.value}
      onChange={(choice) => setChoice(choice)}
      components={{
        IndicatorSeparator: () => null,
        Control: (props) => <Control {...props} lable={placeholder} />
      }}
      // styles={colourStyles}
      classNames={{
        control: (state) => 
          state.hasValue ? 'react-select__control react-select__control--value' : 'react-select__control',
        option: (state) => getOptionClassList(state),
        menu: () => 'react-select__menu',
        valueContainer: (state) =>
          state.hasValue ? 'react-select__value' : ''
      }}
    />
  )
}
